import { render } from "./modalChangeTelnumber.vue?vue&type=template&id=bbedfae6&scoped=true"
import script from "./modalChangeTelnumber.vue?vue&type=script&lang=js"
export * from "./modalChangeTelnumber.vue?vue&type=script&lang=js"

import "./modalChangeTelnumber.vue?vue&type=style&index=0&id=bbedfae6&scoped=true&lang=css"
import "@/assets/css/style_parts.css?vue&type=style&index=1&id=bbedfae6&lang=css&scoped=true"
import "@/assets/css/style_form_parts.css?vue&type=style&index=2&id=bbedfae6&lang=css&scoped=true"
import "@/assets/css/style_mypage.css?vue&type=style&index=3&id=bbedfae6&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbedfae6"]])

export default __exports__